import { giphyBlack } from '@giphy/colors'
import styled from 'styled-components'
import { Toggle } from 'ui'
import CreationToolUploadField from '../../../types/upload-field'
import CollapsibleField from './field-collapsible'
import { Instructions } from './field-instructions'

const VisiblityToggle = styled(Toggle)`
    width: 200px;
`

type Props = {
    className?: string
    field: CreationToolUploadField
    instructions?: string
    isPublic?: boolean
    onChange: (isPrivate: boolean) => void
}

const CreationPrivacyField = ({ className, field, isPublic = false, instructions, onChange }: Props) => {
    const learnMoreUrl = CreationToolUploadField.learnMoreUrl(field)

    return (
        <CollapsibleField className={className} field={field}>
            <VisiblityToggle
                backgroundColor={giphyBlack}
                gradientOff="blue-green"
                gradientOn="red-pink"
                isOn={!isPublic}
                labelOff="Public"
                labelOn="Private"
                size="medium"
                onChange={(value) => onChange(!value)}
            />
            {instructions && (
                <Instructions>
                    {instructions}{' '}
                    {learnMoreUrl && (
                        <a href={learnMoreUrl} target="_blank" rel="noopener noreferrer">
                            Learn More
                        </a>
                    )}
                </Instructions>
            )}
        </CollapsibleField>
    )
}

export default CreationPrivacyField
